import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MessageViewFileDto } from '@src/api-messenger';
import { EnvService } from '@src/app/modules/env';
import { AlertService } from '@src/core/services';

import { MessageService } from '../services';

import { DownloadFileButtonMode } from './types';

@Component({
  selector: 'download-file-button',
  templateUrl: './download-file-button.component.html',
  styleUrls: ['./download-file-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DownloadFileButtonComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly messageService = inject(MessageService);
  private readonly env = inject(EnvService);
  private readonly alertService = inject(AlertService);

  @Input() mode: DownloadFileButtonMode = 'text';
  @Input() file?: MessageViewFileDto;
  @Input() chatId?: string;

  loading = false;

  stopDownloading$$ = new Subject<void>();

  downloadFile(): void {
    const fileId = this.file?.fileId;
    const fileName = this.file?.fileName;

    if (!fileId || !fileName || !this.chatId) {
      // TODO: вывести ошибку
      return;
    }

    this.loading = true;

    this.messageService
      .downloadMessageFile(fileId, this.chatId)
      .pipe(takeUntil(this.stopDownloading$$))
      .subscribe({
        next: blob => {
          this.env.downloadFile({ data: blob, fileName });
        },
        error: err => {
          // TODO: вывести ошибку
          this.alertService.error(err);
        },
        complete: () => {
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }

  stopFileDownload() {
    this.stopDownloading$$.next();
  }
}
